export enum EditableTableColumns {
  VALUE = 'value',
  MODIFIER = 'modifier',
  DESCRIPTION = 'description',
  NAME = 'name',
}
